import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Spinner from "../../components/helpers/Spinner";
import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";
import { fetchAxiosNoToken } from "../../helpers/fetchAxiosNoToken";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { useDispatchDominio } from "../../hooks/useDispatchDominio";
import { getHouse } from "../../redux/reducers/onboardingReducer";
import { Capacidad } from "../design1/Design1";
import { Habitacion } from "../../pages/onboardingPropietario/habitaciones/Habitaciones";

interface Props {
    modalVisible: boolean;

    setModalVisible: (visible: boolean) => void;
}

export const ModalEditRedesSociales = ({
    modalVisible,

    setModalVisible,
}: Props) => {
    const {
        facebook,
        instagram,
        tiktok,
        id: casa_id,
        id_propietario,
    } = useAppSelector((state) => state.landing_house.house);
    const dispatchDominio = useDispatchDominio();
    const [saving, setSaving] = useState<boolean>(false);
    const [input, setInput] = useState({
        instagram: instagram,
        facebook: facebook,
        tiktok: tiktok,
    });
    console.log({
        facebook,
        instagram,
        tiktok,
    });
    // useEffect(() => {
    //     if (capacidades) {
    //         setInput(capacidades);
    //     }
    // }, [idCasa]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async () => {
        setSaving(true);

        try {
            await fetchAxiosToken({
                url: `/casa/updateRedesSociales/${casa_id}`,
                method: "put",
                body: input,
            });

            setTimeout(() => {
                Swal.fire({
                    confirmButtonColor: "#029BFC",
                    iconColor: "#029BFC",
                    title: "Actualizado",
                    text: "Redes actualizadas",
                    icon: "success",
                    confirmButtonText: "Ok",
                });
                setSaving(false);

                dispatchDominio();
                setModalVisible(false);
            }, 2000);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}>
            <div className="flex flex-col items-center justify-center max-w-lg gap-4 p-4 mx-auto text-gray-600 ">
                <h2 className="text-4xl text-[#1C4CBB] text-center font-medium">
                    Editar Redes Sociales
                </h2>
                <hr className="w-full bg-gray-300" />

                <div className="flex flex-col justify-center w-10/12">
                    <label className="ml-2 text-xl font-medium">
                        Instagram
                    </label>
                    <input
                        type={"text"}
                        min={0}
                        name="instagram"
                        value={input.instagram}
                        onChange={handleInputChange}
                        className="w-full max-w-sm p-3 mx-auto mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />
                </div>
                <div className="flex flex-col justify-center w-10/12">
                    <label className="ml-2 text-xl font-medium">Facebook</label>
                    <input
                        type={"text"}
                        min={0}
                        name="facebook"
                        value={input.facebook}
                        onChange={handleInputChange}
                        className="w-full max-w-sm p-3 mx-auto mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />
                </div>
                <div className="flex flex-col justify-center w-10/12">
                    <label className="ml-2 text-xl font-medium">Tiktok</label>
                    <input
                        type={"text"}
                        min={0}
                        step={1}
                        name="tiktok"
                        value={input.tiktok}
                        onChange={handleInputChange}
                        className="w-full max-w-sm p-3 mx-auto mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />
                </div>

                <div className="w-10/12 mt-8 ">
                    {saving ? (
                        <Spinner />
                    ) : (
                        <button
                            onClick={() => handleSubmit()}
                            className="w-full p-3 px-5 text-white border rounded-lg bg-[#1C4CBB] hover:scale-105">
                            Guardar cambios
                        </button>
                    )}
                </div>
            </div>
        </ResponsiveModalAbsolute>
    );
};
